<template>

  <div>
    <h2 class="heading text-center no-margin">{{deviceName}}</h2>
    <h4 class="text-muted">
      {{$t('message.spots.message.supportConnection')}}
    </h4>
    <app-connection-support-section :config="config"></app-connection-support-section>
    <div class="segment">

    </div>
  </div>

</template>

<script>
    import EventBus from '@packages/event-bus'
    import AppConnectionSupportSection from './sections/ConnectionSupportSection'

    export default {
        components: {
            AppConnectionSupportSection
        },

        data() {
            return {
                id : null,
                deviceName: null,
                connectionSupportTypes: [],
                config: {}
            }
        },

        mounted() {
            EventBus.$on('RESET_DEVICE_CONNECTION_SUPPORT_MODAL', this.load)
        },

        beforeDestroy() {
            EventBus.$off('RESET_DEVICE_CONNECTION_SUPPORT_MODAL', this.load)
        },



        methods: {
            reset(form) {
                if (form) {
                    this.form = form
                } else {
                    this.form = {}
                }
            },

            load(params) {
                this.reset();
                this.id = params.id
                this.deviceName = params.name
                this.config = params.config
                EventBus.$emit('LOAD_VPN_SUPPORT')
            }
        },

    }

</script>

<style scoped>
.card-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 15px;
}
.segment {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}
.heading {
  padding-top: 10px;
}
h4 {
  text-align: center;
}
</style>
